export default "__VITE_ASSET__Dq09Koy6__"